export default __webpack_public_path__ + "static/predicting-failures-b4296404add97a268b9df4c6a32d2652.webp";